/* ============================================================
   NOBS & CO — utilidades de carrinho (redesign 2026)
   - Barra de progresso de frete grátis (atualiza via /cart.js)
   - Botões "Adicionar" via AJAX (/cart/add.js), sem reload
   - Sincroniza a bolha do carrinho do Dawn (Section Rendering API)
   ============================================================ */
(function () {
  'use strict';

  var money = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });

  function formatCents(cents) {
    return money.format(cents / 100);
  }

  /* Atualiza todas as barras de progresso de frete da página
     com o total atual do carrinho (em centavos). */
  function updateProgressBars(cartTotal) {
    document.querySelectorAll('[data-nobs-shipping-bar]').forEach(function (bar) {
      var goal = parseInt(bar.dataset.goal, 10) || 0;
      if (!goal) return;

      var remaining = Math.max(0, goal - cartTotal);
      var pct = Math.min(100, (cartTotal / goal) * 100);

      var fill = bar.querySelector('[data-nobs-fill]');
      if (fill) {
        fill.style.width = pct + '%';
        fill.classList.toggle('nobs-progress__fill--done', remaining === 0);
      }

      var remainingEl = bar.querySelector('[data-nobs-remaining]');
      if (remainingEl) remainingEl.textContent = formatCents(remaining);

      var currentEl = bar.querySelector('[data-nobs-current]');
      if (currentEl) currentEl.textContent = formatCents(cartTotal);

      var pending = bar.querySelector('[data-nobs-when-pending]');
      var done = bar.querySelector('[data-nobs-when-done]');
      if (pending) pending.hidden = remaining === 0;
      if (done) done.hidden = remaining > 0;
    });
  }

  function refreshFromCart() {
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateProgressBars(cart.total_price);
        return cart;
      })
      .catch(function () {});
  }

  // Exposto pra outras partes (PDP, etc.) atualizarem as barras de frete da
  // página em tempo real depois de mexer no carrinho.
  window.NobsBars = { refresh: refreshFromCart };

  /* Atualiza só o CONTADOR da bolha do carrinho — não mexe no ícone
     (o header usa o ícone próprio do redesign, não o do Dawn). */
  function refreshCartBubble() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var target = document.getElementById('cart-icon-bubble');
        if (!target) return;
        var bubble = target.querySelector('.cart-count-bubble');
        if (c.item_count > 0) {
          if (!bubble) {
            bubble = document.createElement('div');
            bubble.className = 'cart-count-bubble';
            target.appendChild(bubble);
          }
          bubble.innerHTML = '<span aria-hidden="true">' + (c.item_count < 100 ? c.item_count : '99') + '</span>';
        } else if (bubble) {
          bubble.parentNode.removeChild(bubble);
        }
      })
      .catch(function () {});
  }

  /* Botões de adicionar ao carrinho via AJAX. */
  function bindAddButtons() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-nobs-add]');
      if (!btn) return;
      e.preventDefault();

      var variantId = btn.dataset.variantId;
      if (!variantId || btn.disabled) return;

      var originalHtml = btn.innerHTML;
      btn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('add failed');
          return r.json();
        })
        .then(function () {
          btn.innerHTML = '<span>Adicionado</span> ✓';
          refreshFromCart();
          refreshCartBubble();
          // abre o drawer do carrinho, se estiver disponível
          if (window.NobsCart && typeof window.NobsCart.openRefreshed === 'function') {
            window.NobsCart.openRefreshed();
          }
          setTimeout(function () {
            btn.innerHTML = originalHtml;
            btn.disabled = false;
          }, 2500);
        })
        .catch(function () {
          btn.innerHTML = originalHtml;
          btn.disabled = false;
        });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    bindAddButtons();
    refreshFromCart();
  });
})();
